import { render, staticRenderFns } from "./DentList.vue?vue&type=template&id=fd5f747c&scoped=true&"
import script from "./DentList.vue?vue&type=script&lang=js&"
export * from "./DentList.vue?vue&type=script&lang=js&"
import style0 from "./DentList.vue?vue&type=style&index=0&id=fd5f747c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5f747c",
  null
  
)

export default component.exports